'use strict';
import { addBrowserClasses } from './modules/_utils';
import Glide from '@glidejs/glide';
import { modal } from "./modules/modal";
modal();


document.addEventListener('DOMContentLoaded', function() {


  document.getElementsByClassName('no-js')[0].classList.remove('no-js');

  // Common functions
  addBrowserClasses();

  // Hubspot cookie settings links in footer
  const hubspotCookieSettings = document.getElementById('hs-footer-cookie-settings');
  if (hubspotCookieSettings) {
    hubspotCookieSettings.addEventListener('click', function(e) {
      e.preventDefault();
      var _hsp = window._hsp = window._hsp || [];
      _hsp.push(['showBanner']);
    });
  }


  // if (document.getElementById('hero-video')) {
  //   var player = videojs('hero-video');

  //   player.ready(function() {
  //     var promise = player.play();

  //     if (promise !== undefined) {
  //       promise.then(function() {
  //         jQuery('.vjs-play-control').removeClass('vjs-paused');
  //         jQuery('.vjs-play-control').addClass('vjs-playing');
  //       }).catch(function(error) {
  //         // Autoplay was prevented.
  //       });
  //     }
  //   });

  // }

  const menuBtn = document.getElementById("mobile-menu-btn");
  const navMain = document.getElementById("nav-main");
  const overlay = document.getElementById("overlay");
  const desktopOverlay = document.getElementById("overlay-desktop");
  const hasSub = document.querySelectorAll(".has-sub");
  const hasSubLink = document.querySelectorAll(".has-sub > a");
  const subMenu = document.querySelector(".sub-menu");

  const toggleMenu = () => {
    menuBtn.classList.toggle("open");
    navMain.classList.toggle("open");
    overlay.classList.toggle("open");
  }
  const closeMenu = () => {
    menuBtn.classList.remove("open");
    navMain.classList.remove("open");
    overlay.classList.remove("open");

  }
  menuBtn.addEventListener('click', () => toggleMenu());

  document.addEventListener("keyup", function(e) {
    if (e.key === "Escape") closeMenu();
  });

  // Always fire closeMenu() at 1024px breakpoint
  const mq = window.matchMedia("screen and (min-width: 1024px)");
  mq.addEventListener("change", (event) => {
    if (event.matches) closeMenu();
  });

  overlay.addEventListener('click', closeMenu);



  const handleMouseEnter = () => {
    desktopOverlay.style.visibility = 'visible';
    desktopOverlay.style.opacity = 1;
  };

  const handleMouseLeave = () => {
    desktopOverlay.style.visibility = 'hidden';
    desktopOverlay.style.opacity = 0;
  };


  hasSubLink.forEach(link => {
    link.addEventListener('click', (event) => event.preventDefault());
  });

  hasSub.forEach(item => {
    item.addEventListener('click', (event) => {
      let sub = item.querySelector('.sub-menu');
      sub.classList.toggle('active');
    });
    item.addEventListener('mouseenter', handleMouseEnter);
    item.addEventListener('mouseleave', handleMouseLeave);
  });

  const linkItems = document.querySelectorAll('.links a');
  linkItems.forEach(link => {
    link.addEventListener('click', () => {
      document.querySelector('.links').querySelectorAll('.active').forEach(el => el.classList.remove('active'));
      link.classList.add('active');
      let activeItem = document.querySelector('.links a.active');
      let activePosition = activeItem.offsetLeft - 16;
      document.querySelector('.links').scrollTo(activePosition, 0);
    })
  })


  const clickToShow = (element) => {
    const images = element.querySelectorAll('img');
    const listItems = element.querySelectorAll('ul li');

    images.forEach((img, index) => img.dataset.value = index);
    listItems.forEach((li, index) => li.dataset.value = index);

    listItems.forEach(li => {
      li.addEventListener('click', () => {
        element.querySelectorAll('.active').forEach(el => el.classList.remove('active'));
        images.forEach(img => {
          if (li.dataset.value === img.dataset.value) {
            li.classList.add('active');
            img.classList.add('active');
          }
        })
      });
    });
  }

  if (document.querySelector('.page-template-wfai')) {

    clickToShow(document.getElementById('wf-planning'));
    clickToShow(document.getElementById('pred-sched'));
    clickToShow(document.getElementById('pred-staff'));

    const glideSlider = new Glide('.glide', {
      type: 'carousel',
      perView: 3,
      gap: 24,
      animationDuration: 600,
      breakpoints: {
        1024: {
          perView: 2,
        },
        768: {
          perView: 1,
        }
      }
    });

    glideSlider.mount();

  }



  // Stop any animation/transition while window is being resized
  let resizeTimer;
  window.addEventListener("resize", () => {
    document.body.classList.add("resize-animation-stopper");
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.body.classList.remove("resize-animation-stopper");
    }, 400);
  });

});



// Secondary nav
const navUtility = document.querySelector('#nav_utility_wrapper nav.nav-utility');
const navUtilityContainer = document.querySelector('#nav_utility_wrapper .container');
const activeMenuItem = document.querySelector('#nav_utility_wrapper .current-menu-item');

if (navUtility) {

  const toggleNavUtility = () => {
    navUtility.classList.toggle('open');
  };

  const handleResize = () => {
    if (window.innerWidth >= 1024 && navUtility.classList.contains('open')) {
      navUtility.classList.remove('open');
    }
  };

  const manageClickListener = () => {
    if (window.innerWidth < 1024 && !navUtilityContainer.clickListenerAttached) {
      navUtilityContainer.addEventListener('click', toggleNavUtility);
      navUtilityContainer.clickListenerAttached = true;
    } else if (window.innerWidth >= 1024 && navUtilityContainer.clickListenerAttached) {
      navUtilityContainer.removeEventListener('click', toggleNavUtility);
      navUtilityContainer.clickListenerAttached = false;
    }
  };

  manageClickListener();

  window.addEventListener('resize', () => {
    handleResize();
    manageClickListener();
  });

  document.addEventListener("keyup", (e) => {
    if (e.key === "Escape") navUtility.classList.remove('open');
  });
  document.addEventListener('click', (e) => {
    if (!navUtility.contains(e.target)) navUtility.classList.remove('open');
  })

  activeMenuItem.addEventListener('click', (e) => e.preventDefault());

}


